import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '../../../Button';
import Title from '../../../Title';
import { getDealInfo } from '../../../../reducers/DealInfo';
import { geti18n } from '../../../../reducers/i18n';
class ServicesDescription extends Component {
  render() {
    const i18n = this.props.i18n;
    const { next } = this.props;
    const detailsInfo = this.props.detailsInfo;
    return (
      <div className="services-descriptions text-center row justify-content-center">
        <div className="col-10 col-md-9">
          <Title text={i18n('onboarding.servicesDescription.mainTitle')} className="form__title" />
          <div className="d-flex justify-content-center">
            <h3 className="text-large font-weight-bold mb-5 w-75">{i18n('onboarding.servicesDescription.subTitle')}</h3>
          </div>
          <div className="row mb-5">
            <div className="col-12 col-sm-4 mb-4 mb-sm-0 pb-2 pb-sm-0">
              <h3 className="text-large font-weight-bold mb-3">{i18n('onboarding.servicesDescription.title1')}</h3>
              <p className="mb-0">{i18n('onboarding.servicesDescription.description1')}</p>
            </div>
            <div className="col-12 col-sm-4 mb-4 mb-sm-0 pb-2 pb-sm-0">
              <h3 className="text-large font-weight-bold mb-3">{i18n('onboarding.servicesDescription.title2')}</h3>
              <p className="mb-0">{i18n('onboarding.servicesDescription.description2')}</p>
            </div>
            <div className="col-12 col-sm-4">
              <h3 className="text-large font-weight-bold mb-3">{i18n('onboarding.servicesDescription.title3')}</h3>
              <p className="mb-0">{i18n('onboarding.servicesDescription.description3')}</p>
            </div>
          </div>
          <h3 className="text-large font-weight-bold mb-4">{i18n('onboarding.servicesDescription.price1')}
            {detailsInfo.get("membershipFee")}{' '}{i18n('onboarding.servicesDescription.price2')}</h3>
          <Button text={i18n('onboarding.servicesDescription.buttonText')} onClick={next} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  detailsInfo: getDealInfo(state),
  i18n: geti18n(state),
});

export default connect(mapStateToProps)(ServicesDescription);



// WEBPACK FOOTER //
// ./src/components/Views/Onboarding/Steps/ServicesDescription.js